export const getters = {
  GET_ACCOUNT_ID: state => state.accountId,
  GET_FIELDS: state => {
    const legalFields = state.fields.legal.map(field => {
      if (state.selectedCountry !== 'BRASIL') {
        if (field.name === 'phone') {
          const mask = state.selectedCountry === 'ARGENTINA' ? ['+54 ############'] : ['+598 ############']
          return { ...field, mask, validators: { required: true } }
        }
        if (field.name === 'birth_date') {
          return { ...field }
        }
        return { ...field, mask: null }
      }
      return { ...field }
    })
    const naturalFields = state.fields.natural.map(field => {
      if (state.selectedCountry !== 'BRASIL') {
        if (field.name === 'phone') {
          const mask = state.selectedCountry === 'ARGENTINA' ? ['+54 ############'] : ['+598 ############']
          return { ...field, mask, validators: { required: true } }
        }
        if (field.name === 'birth_date') {
          return { ...field }
        }
        return { ...field, mask: null }
      }
      return { ...field }
    })
    return {
      allowed_person_types_signup: [...state.fields.allowed_person_types_signup],
      legal: [...legalFields],
      natural: [...naturalFields]
    }
  },
  GET_ALLOWED_PERSON_TYPES_SIGNUP: state => state.allowed_person_types_signup,
  GET_IS_NATURAL_PERSON: state => (state.USER_INFO ? state.USER_INFO.person_type === 'N' : false),
  GET_ASSETS: state => state.assets,
  GET_TERMS: state => state.terms,
  GET_POSITION: state => state.position,
  LOADING: state => state.loading,
  LOADING_ID: state => state.loadingId,
  USER_INFO: state => state.userInfo,
  TOKEN: state => state.access_token,
  IS_APP: state => state.isApp,
  HIDDEN_EMAIL: state => state.hidden_email,
  HIDDEN_PHONE: state => state.hidden_phone,
  DELETE_REQUEST: state => state.delete_request,
  IS_CONFIRMED: state => state.is_confirmed,
  USER_EMAIL: state => state.user_email,
  CONTACTS: state => state.contacts,
  PIXEL: state => state.facebook_pixel_id,
  GOOGLE_ANALYTICS: state => state.google_analytics_id,
  ALLOWED_COUNTRIES: state => state.allowed_countries,
  SELECTED_COUNTRY: state => state.selectedCountry,
  SMS_CHANNEL: state => state.smsChannel,
  COOLDOWN: state => state.cooldown,
  MESSAGE_SENT: state => state.message_sent,
  IS_RECOVER_SMS: state => state.is_recover_sms,
  SOCIAL_MEDIA: state => state.socialMedia,
  LOGIN_MENU: state => state.login_menu,
  SHOW_DELETE_BUTTONS: state => state.show_delete_buttons,
  SHOW_PARTIAL_DELETE_BUTTONS: state => state.show_partial_delete_buttons,
  ALLOWED_MODULES: state => state.allowed_modules,
  CAPTCHA_KEY: state => state.captcha_key,
  FINISH_SCREEN_WHATSAPP: state => state.finishScreenWhatsapp,
  APP_STORES: state => state.appStores,
  IS_EXTERNAL_AUTH: state => state.isExternalAuth
}
